/* src/app/components/discovery/create-production-job/create-production-job.component.scss */
.main-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.info-text {
  color: rgba(0, 0, 0, 0.54);
}
:host-context(.dark-theme) .info-text {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=create-production-job.component.css.map */
